import {Component, OnInit} from '@angular/core';
import {ServerService} from '../../shared/services/server.service';
import {Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { companyName } from '../../shared/global';

interface UserData {
  username: string,
  password: string
}

interface ISlide {
  image: string;
  active?: boolean;
}

@Component({
  selector: 'app-page-login',
  templateUrl: './page-login.component.html',
  styleUrls: ['./page-login.component.scss']
})
export class PageLoginComponent implements OnInit {

  loading: boolean = false;

  errorMessage = '';

  public data: UserData = {
    username: '',
    password: ''
  };

  public slides: ISlide[] = [
    {image: './assets/bgs/1.jpg', active: true},
    {image: './assets/bgs/2.jpg', active: false},
    {image: './assets/bgs/3.jpg', active: false},
    {image: './assets/bgs/4.jpg', active: false},
  ];

  gifUrl = '';
  folderSrc = './assets/animation/';
  interval;
  index = 1;
  refreshToken: string;

  companyName = companyName;
  mail = 'khc@idet.kz';

  constructor(private service: ServerService, private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
    this.route.queryParams
    .subscribe(params => {
      if (params.secret) {
        localStorage.clear();
        this.refreshToken = params.secret;
        this.authWithRefreshToken();
      }
    });


    this.interval = setInterval(() => {
      if (this.index < 10) {
        this.gifUrl = this.folderSrc + '1_0000' + this.index + '.png';
      } else if (this.index >= 10 && this.index < 100) {
        this.gifUrl = this.folderSrc + '1_000' + this.index + '.png';
      } else if (this.index >= 100) {
        this.gifUrl = this.folderSrc + '1_00' + this.index + '.png';
      }
      this.index++;
      if (this.index === 127) {
        this.index = 94;
      }
    }, 55);

    setInterval(() => {
      let image = this.slides.filter(s => s.active)[0];
      if (image) {
        let index = this.slides.indexOf(image);
        if (index == this.slides.length-1) {
          index = 0;
        }
        this.slides.forEach(s => s.active = false);
        this.slides[index+1].active = true;
      }
    }, 3500);

    let token = localStorage.getItem('token');
    if (token) {
      return this.router.navigate(['/main']);
    }
  }

  authWithRefreshToken() {
    this.loading = true;
    this.service.getTokenWithRefreshToken(this.refreshToken).then(res => {
      if (res) {
        localStorage.setItem('token', res.access_token);
        this.service.getUserInfo(res.userName).then(r => {
          localStorage.setItem('user', JSON.stringify(r));
          this.loading = false;
          return this.router.navigate(['/main']);
        }, (err: any) => {
          if (err.status == 401) {
            localStorage.clear();
            this.loading = false;
            return this.router.navigate(['/login']);
          }
        });
      }
    }, (err: any) => {
      if (err.status == 400) {
        this.errorMessage = err.error.error_description;
        this.loading = false;
      }
      if (err.status == 0) {
        this.loading = false;
        return this.router.navigate(['/login']);
      }
    });
  }

  auth() {
    this.loading = true;
    this.service.getToken(this.data.username, this.data.password).then(res => {
      if (res) {
        localStorage.setItem('token', res.access_token);
        this.service.getUserInfo(res.userName).then(r => {
          localStorage.setItem('user', JSON.stringify(r));
          this.loading = false;
          return this.router.navigate(['/main']);
        }, (err: any) => {
          if (err.status == 401) {
            localStorage.clear();
            this.loading = false;
            return this.router.navigate(['/login']);
          }

        });
      }
    }, (err: any) => {
      if (err.status == 400) {
        this.errorMessage = err.error.error_description;
        this.loading = false;
      }
      if (err.status == 0) {
        // this.errorMessage = 'К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позжеxxxx';
        this.loading = false;
        return this.router.navigate(['/login']);
      }
    });
  }

  authByEnter(event) {
    if (event.keyCode == 13) {
      this.auth();
    }
  }

}
